import { QRCodeSVG } from 'qrcode.react';

/** QR Code (C-25). */
export default function QrCode({ value, size = 148 }: { value: string; size?: number }) {
  return (
    <div style={{ background: '#fff', padding: 10, borderRadius: 12, border: '1px solid var(--line)', alignSelf: 'center' }}>
      <QRCodeSVG value={value} size={size} fgColor="#15302c" level="M" />
    </div>
  );
}
